import {useArabicRulesInCombineNode} from "@/components/widgets/list_download/common.js";

function washFn(walkedNode, item){
  if(walkedNode.modeData && walkedNode.modeData[item.flag]){
    walkedNode.modeData[item.flag] = useArabicRulesInCombineNode({
      componentName: item.componentName,
      data: walkedNode.modeData[item.flag]
    }).data
  }
}

export function washData(walkedNode){
  if(walkedNode._type === 'list_news_index_style1'){
    [{
      flag: 'caseList_listItem_right_title',
      componentName: 'text_title',
    },{
      flag: 'caseList_listItem_right_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'caseList_listItem_left_image',
      componentName: 'image_image1',
    },{
      flag: 'caseList_listItem_right_btn',
      componentName: 'button_text',
    },{
      flag: 'caseList_listItem_right_date',
      componentName: 'text_paragraph',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
    walkedNode._type === 'list_news_index_style3' ||
    walkedNode._type === 'list_news_index_style4'
  ){
    [{
      flag: 'caseList_listItem_thirdPart_title',
      componentName: 'text_title',
    },{
      flag: 'caseList_listItem_right_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'caseList_listItem_right_btn',
      componentName: 'button_text',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
    walkedNode._type === 'list_news_index_style5'
  ){
    [{
      flag: 'productList_listItem_title',
      componentName: 'text_title',
    },{
      flag: 'productList_listItem_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'productList_listItem_button',
      componentName: 'button_text',
    },{
      flag: 'productList_listItem_date',
      componentName: 'text_paragraph',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
    walkedNode._type === 'list_news_index_style6'
  ){
    [{
      flag: 'productList_listItem_title',
      componentName: 'text_title',
    },{
      flag: 'productList_listItem_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'productList_listItem_button',
      componentName: 'button_text',
    },{
      flag: 'productList_listItem_date_icon',
      componentName: 'icon',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
    walkedNode._type === 'list_news_index_style7'
  ){
    [
      {
        flag: 'topCard_date_icon',
        componentName: 'icon',
      },
      {
        flag: 'topCard_img',
        componentName: 'image_image1',
      },
      {
        flag: 'topCard_title',
        componentName: 'text_title',
      },{
        flag: 'topCard_paragraph',
        componentName: 'text_paragraph',
      },{
        flag: 'productList_listItem_title',
        componentName: 'text_title',
      },{
        flag: 'productList_listItem_paragraph',
        componentName: 'text_paragraph',
      },{
        flag: 'productList_listItem_date',
        componentName: 'text_paragraph',
      },
      {
      flag: 'productList_listItem_devider',
      componentName: 'divider',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }

}
